export default function isOpeningAvailable(opening) {
  if (!opening) {
    return false;
  }
  const pendingUntil = Date.parse(opening.pendingUntil);
  if (Number.isNaN(pendingUntil)) {
    return true;
  }
  return pendingUntil < Date.now();
}
